export const SCREEN_PADDING = 16;
